/** @module qt.router setting相关
 *  @description 设置相关路由
 */
import { inApp } from '../env';
import { invokeSchema } from '../base';

/**
 * 跳转配置中心
 * @example
 * ```
 * qt.route.jumpToSetting()
 * ```
 */
export function jumpToSetting(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/settings');
}

/**
 * 跳转清理缓存页
 * @example
 * ```
 * qt.route.jumpToSettingDeleteCache()
 * ```
 */
export function jumpToSettingDeleteCache(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/settings/deletecache');
}

/**
 * 跳转关于蜻蜓页
 * @example
 * ```javascript
 * qt.route.jumpToSettingAboutQt()
 * ```
 */
export function jumpToSettingAboutQt({
  awakeApp,
}: {
  /** 站外直接唤醒APP而不是跳转 */
  awakeApp?: boolean;
}): Promise<unknown> {
  if (inApp || awakeApp) {
    return invokeSchema('qingtingfm://app.qingting.fm/settings/aboutqt');
  }
  window.location.href = 'https://sss.qingting.fm/about.html';
  return Promise.resolve();
}
/** @ignore */
export const setting = {
  jumpToSetting,
  jumpToSettingDeleteCache,
  jumpToSettingAboutQt,
};
